<div
  class="ai-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="ai-modal-heading"
  (keydown)="$event.stopPropagation()"
>
  <div class="ai-modal__backdrop" aria-hidden="true" (click)="onClose()"></div>
  <div class="ai-modal__panel" (click)="$event.stopPropagation()">
    <header class="ai-modal__header">
      <div class="ai-modal__header-text">
        <h2 id="ai-modal-heading" class="ai-modal__title">
          {{ isEdit ? 'Modify Additional Info' : 'Additional Info' }}
        </h2>
        @if (assetLabel()) {
          <p class="ai-modal__subtitle">
            {{ assetKindLabel() }}: {{ assetLabel() }}
          </p>
        }
      </div>
      <button
        type="button"
        class="ai-modal__close"
        (click)="onClose(); $event.stopPropagation()"
        aria-label="Close additional information dialog"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </header>

    <div class="ai-modal__body">
      @if (loading) {
        <p class="ai-modal__status">Loading additional information…</p>
      } @else if (isEdit) {
        <lib-additional-info-edit
          [initialFaqRows]="editFaqRows"
          [initialInfoText]="editInfoText"
        />
      } @else {
        <lib-additional-info />
      }
    </div>

    <footer class="ai-modal__footer">
      <button
        type="button"
        class="ai-modal__submit"
        [disabled]="!canSubmit"
        (click)="onSubmit()"
      >
        {{ submitLabel }}
      </button>
    </footer>
  </div>
</div>
